<template>
  <div>
    <AdminDashboard v-if="currentUser.role === roles.admin" />
    <StateHeadDashboard v-else-if="currentUser.role === roles.stateHead" />
    <AgencyHeadDashboard v-else-if="currentUser.role === roles.agencyHead" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import rolesData from '@/data/roles'
import AdminDashboard from './components/AdminDashboard'
import StateHeadDashboard from './components/StateHeadDashboard'
import AgencyHeadDashboard from './components/AgencyHeadDashboard'

export default {
  name: 'Dashboard',
  components: {
    AdminDashboard,
    StateHeadDashboard,
    AgencyHeadDashboard
  },
  data () {
    return {
      roles: rolesData
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  }
}
</script>
